(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  function initializePageAccordions(root) {
    root.querySelectorAll('.static-page-wrapper .accordion-header').forEach((header, index) => {
      if (header.dataset.accordionReady) return;
      const body = header.nextElementSibling;
      if (!body || !body.classList.contains('accordion-body')) return;

      header.dataset.accordionReady = 'true';
      body.id ||= `${header.closest('[id]').id}-accordion-panel-${index}`;
      header.setAttribute('role', 'heading');
      header.setAttribute('aria-level', '2');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'page-accordion__button';
      button.setAttribute('aria-controls', body.id);
      header.querySelectorAll('h2, h3, h4, h5, h6').forEach((heading) => {
        const label = document.createElement('span');
        label.className = `${heading.className} ${heading.tagName.toLowerCase()}`;
        label.style.cssText = heading.style.cssText;
        label.append(...heading.childNodes);
        heading.replaceWith(label);
      });
      button.append(...header.childNodes);
      header.append(button);
      header.querySelector('.accordion-arrow')?.setAttribute('aria-hidden', 'true');
      const sync = () => {
        const open = body.classList.contains('open');
        button.setAttribute('aria-expanded', String(open));
        body.hidden = !open;
        header.querySelector('.accordion-arrow')?.classList.toggle('open', open);
      };
      sync();
      header.addEventListener('click', () => {
        // Content with its own click handler retains that behavior.
        if (!header.hasAttribute('onclick')) body.classList.toggle('open');
        sync();
      });
    });
    root.querySelectorAll('.static-page-wrapper .static-table-wrap').forEach((table) => {
      table.tabIndex = 0;
    });
  }

  /*
   * In-page links written in the page editor sometimes point at an id that does not exist (for example
   * "#16" when the heading has id "17" or none at all), or at the wrong heading after a section was added.
   * When a heading's text matches the link text exactly, the link goes to that heading (which gets an id
   * if it has none). Otherwise a link whose target exists is left alone.
   */
  function repairPageAnchors(root) {
    const normalize = (text) => (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    const words = (text) => new Set(normalize(text).replace(/[^\p{L}\p{N}\s]/gu, ' ').split(' ').filter(Boolean));
    // Share of words two texts have in common (0 to 1); used when link and heading wording differ slightly.
    const similarity = (a, b) => {
      const wordsA = words(a);
      const wordsB = words(b);
      if (!wordsA.size || !wordsB.size) return 0;
      let shared = 0;
      wordsA.forEach((word) => wordsB.has(word) && (shared += 1));
      return shared / Math.max(wordsA.size, wordsB.size);
    };
    root.querySelectorAll('.static-page-wrapper .rte').forEach((content) => {
      // Fuzzy title matching and the explicit scroll below are only for the Terms of Use page.
      const anchorLinksFix = content.closest('[data-anchor-links-fix]') !== null;
      const headings = Array.from(content.querySelectorAll('h1, h2, h3, h4, h5, h6'));
      content.querySelectorAll('a[href^="#"]').forEach((link) => {
        const rawId = decodeURIComponent(link.getAttribute('href').replace(/^#+/, ''));
        const label = normalize(link.textContent);
        let match = label ? headings.find((heading) => normalize(heading.textContent) === label) : null;
        if (!match && label && anchorLinksFix) {
          // No exact text match: take the closest heading, but only when it is clearly the same title.
          let bestScore = 0.6;
          headings.forEach((heading) => {
            const score = similarity(label, heading.textContent);
            if (score > bestScore) {
              bestScore = score;
              match = heading;
            }
          });
        }
        if (match) {
          if (!match.id) match.id = `page-anchor-${headings.indexOf(match) + 1}`;
          link.setAttribute('href', `#${encodeURIComponent(match.id)}`);
        } else if (rawId && document.getElementById(rawId)) {
          link.setAttribute('href', `#${encodeURIComponent(rawId)}`);
        }
      });

      // Another script on the page can cancel the browser's own jump to an in-page link, so the link
      // scrolls to its heading itself and moves keyboard focus there. Capture phase, once per content.
      if (!anchorLinksFix || content.dataset.anchorScrollReady) return;
      content.dataset.anchorScrollReady = 'true';
      content.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest('a[href^="#"]');
          if (!link) return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const id = decodeURIComponent(link.getAttribute('href').replace(/^#+/, ''));
          const target = id ? document.getElementById(id) : null;
          if (!target) return;
          event.preventDefault();
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          history.replaceState(null, '', `#${encodeURIComponent(id)}`);
        },
        true,
      );
    });
  }

  /*
   * The page editor can put a list directly inside another list (<ul><li>..</li><ul>..</ul></ul>), which
   * is invalid HTML. The inner list moves into the item before it, so it keeps its place and indent.
   */
  function repairNestedLists(root) {
    root.querySelectorAll('.static-page-wrapper .rte :is(ul, ol) > :is(ul, ol)').forEach((list) => {
      const previous = list.previousElementSibling;
      if (previous && previous.tagName === 'LI') previous.appendChild(list);
    });
  }

  function initializePage(root) {
    initializePageAccordions(root);
    repairPageAnchors(root);
    repairNestedLists(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializePage(document));
  } else {
    initializePage(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializePage(event.target));

  } catch(e) { console.error(e); }
})();
})();
